import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.filter.js";
var _types$SET_DEFAULT_OR;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { toggleFacetInFilterBy, addUniqFacetInFilterBy } from '~/helpers/filter-helper';
import * as types from './types';
export default (_types$SET_DEFAULT_OR = {}, _defineProperty(_types$SET_DEFAULT_OR, types.SET_DEFAULT_ORDERBY, function (state, payload) {
  var currentState = state;
  currentState.orderBy = payload;
}), _defineProperty(_types$SET_DEFAULT_OR, types.SET_DEFAULT_SORTBY, function (state, payload) {
  var currentState = state;
  currentState.sortBy = payload;
}), _defineProperty(_types$SET_DEFAULT_OR, types.SET_DEFAULT_FILTERBY, function (state, payload) {
  var currentState = state;
  currentState.filterBy = payload;
}), _defineProperty(_types$SET_DEFAULT_OR, types.SORT_BY, function (state, payload) {
  var currentState = state;
  currentState.sortBy = payload;
}), _defineProperty(_types$SET_DEFAULT_OR, types.ORDER_BY, function (state, payload) {
  var currentState = state;
  currentState.orderBy = payload;
}), _defineProperty(_types$SET_DEFAULT_OR, types.FILTER_BY, function (state, _ref) {
  var filter = _ref.filter,
    facet = _ref.facet,
    _ref$uniq = _ref.uniq,
    uniq = _ref$uniq === void 0 ? false : _ref$uniq;
  var currentState = state;
  var transform = uniq ? addUniqFacetInFilterBy : toggleFacetInFilterBy;
  currentState.filterBy = transform(_objectSpread({}, currentState.filterBy), filter, facet);
}), _defineProperty(_types$SET_DEFAULT_OR, types.RESET_FILTERS, function (state) {
  var currentState = state;
  currentState.filterBy = null;
}), _defineProperty(_types$SET_DEFAULT_OR, types.RESET_PAGINATION, function (state) {
  var currentState = state;
  currentState.previousPage = 1;
  currentState.nextPage = 1;
}), _defineProperty(_types$SET_DEFAULT_OR, types.SET_NEXT_PAGE, function (state, payload) {
  var currentState = state;
  currentState.nextPage = payload;
}), _defineProperty(_types$SET_DEFAULT_OR, types.SET_PREVIOUS_PAGE, function (state, payload) {
  var currentState = state;
  currentState.previousPage = payload;
}), _types$SET_DEFAULT_OR);